/* tslint:disable */
/* eslint-disable */
/**
 * Reckon Bolt API
 * Backend API for Reckon Bolt
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
    import type {
        ClientOrganizationVariableDistribution200ResponseInner,
        CompetitiveTeamRoundSummaries,
        CompetitiveTeamRoundSummariesAggregate,
    } from '../models/index';

            export interface CompetitiveTeamRoundSummariesAggregateRequest {
                groupby: Array<string>;
                ordering: Array<string>;
                additional_filters?: object;
                aggregates?: Array<string>;
                assists?: number;
                attack_pattern_full?: string;
                attack_pattern_short?: string;
                bomb_site?: string;
                combat_score?: number;
                damages?: number;
                date?: string;
                deaths?: number;
                defense_pattern_full?: string;
                defense_pattern_short?: string;
                first_blood?: boolean;
                first_death?: boolean;
                first_true_blood?: boolean;
                first_true_death?: boolean;
                game?: string;
                having?: object;
                id?: string;
                index_on?: string;
                kast?: number;
                kills?: number;
                league?: string;
                map?: string;
                metrics?: Array<string>;
                round_eco_type?: string;
                round_eco_type_no_bonus?: string;
                round_end?: string;
                round_index?: number;
                side?: string;
                team1?: string;
                team2?: string;
            }

            export interface CompetitiveTeamRoundSummariesFieldValuesRequest {
                field: string;
                ordering: Array<string>;
                additional_filters?: object;
                assists?: number;
                attack_pattern_full?: string;
                attack_pattern_short?: string;
                bomb_site?: string;
                combat_score?: number;
                damages?: number;
                date?: string;
                deaths?: number;
                defense_pattern_full?: string;
                defense_pattern_short?: string;
                first_blood?: boolean;
                first_death?: boolean;
                first_true_blood?: boolean;
                first_true_death?: boolean;
                game?: string;
                id?: string;
                kast?: number;
                kills?: number;
                league?: string;
                map?: string;
                round_eco_type?: string;
                round_eco_type_no_bonus?: string;
                round_end?: string;
                round_index?: number;
                side?: string;
                team1?: string;
                team2?: string;
            }

            export interface CompetitiveTeamRoundSummariesGetRequest {
                id: string;
            }

            export interface CompetitiveTeamRoundSummariesListRequest {
                additional_filters?: object;
                annotations?: Array<string>;
                assists?: number;
                attack_pattern_full?: string;
                attack_pattern_short?: string;
                bomb_site?: string;
                combat_score?: number;
                damages?: number;
                date?: string;
                deaths?: number;
                defense_pattern_full?: string;
                defense_pattern_short?: string;
                first_blood?: boolean;
                first_death?: boolean;
                first_true_blood?: boolean;
                first_true_death?: boolean;
                game?: string;
                id?: string;
                kast?: number;
                kills?: number;
                league?: string;
                map?: string;
                only_values?: Array<string>;
                ordering?: Array<string>;
                round_eco_type?: string;
                round_eco_type_no_bonus?: string;
                round_end?: string;
                round_index?: number;
                side?: string;
                team1?: string;
                team2?: string;
            }

            export interface CompetitiveTeamRoundSummariesVariableDistributionRequest {
                bucket_size: number;
                max: number;
                metric: string;
                min: number;
                additional_filters?: object;
                assists?: number;
                attack_pattern_full?: string;
                attack_pattern_short?: string;
                bomb_site?: string;
                combat_score?: number;
                damages?: number;
                date?: string;
                deaths?: number;
                defense_pattern_full?: string;
                defense_pattern_short?: string;
                first_blood?: boolean;
                first_death?: boolean;
                first_true_blood?: boolean;
                first_true_death?: boolean;
                game?: string;
                id?: string;
                kast?: number;
                kills?: number;
                league?: string;
                map?: string;
                round_eco_type?: string;
                round_eco_type_no_bonus?: string;
                round_end?: string;
                round_index?: number;
                side?: string;
                team1?: string;
                team2?: string;
            }

        /**
        * 
        */
            export class CompetitiveTeamRoundSummariesApi extends runtime.BaseAPI {

            /**
            */
            async competitiveTeamRoundSummariesAggregateRaw(requestParameters: CompetitiveTeamRoundSummariesAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompetitiveTeamRoundSummariesAggregate>>> {
                    if (requestParameters.groupby === null || requestParameters.groupby === undefined) {
                    throw new runtime.RequiredError('groupby','Required parameter requestParameters.groupby was null or undefined when calling competitiveTeamRoundSummariesAggregate.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling competitiveTeamRoundSummariesAggregate.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.aggregates) {
                        queryParameters['aggregates'] = requestParameters.aggregates;
                    }

                    if (requestParameters.assists !== undefined) {
                            queryParameters['assists'] = requestParameters.assists;
                    }

                    if (requestParameters.attack_pattern_full !== undefined) {
                            queryParameters['attack_pattern_full'] = requestParameters.attack_pattern_full;
                    }

                    if (requestParameters.attack_pattern_short !== undefined) {
                            queryParameters['attack_pattern_short'] = requestParameters.attack_pattern_short;
                    }

                    if (requestParameters.bomb_site !== undefined) {
                            queryParameters['bomb_site'] = requestParameters.bomb_site;
                    }

                    if (requestParameters.combat_score !== undefined) {
                            queryParameters['combat_score'] = requestParameters.combat_score;
                    }

                    if (requestParameters.damages !== undefined) {
                            queryParameters['damages'] = requestParameters.damages;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.deaths !== undefined) {
                            queryParameters['deaths'] = requestParameters.deaths;
                    }

                    if (requestParameters.defense_pattern_full !== undefined) {
                            queryParameters['defense_pattern_full'] = requestParameters.defense_pattern_full;
                    }

                    if (requestParameters.defense_pattern_short !== undefined) {
                            queryParameters['defense_pattern_short'] = requestParameters.defense_pattern_short;
                    }

                    if (requestParameters.first_blood !== undefined) {
                            queryParameters['first_blood'] = requestParameters.first_blood;
                    }

                    if (requestParameters.first_death !== undefined) {
                            queryParameters['first_death'] = requestParameters.first_death;
                    }

                    if (requestParameters.first_true_blood !== undefined) {
                            queryParameters['first_true_blood'] = requestParameters.first_true_blood;
                    }

                    if (requestParameters.first_true_death !== undefined) {
                            queryParameters['first_true_death'] = requestParameters.first_true_death;
                    }

                    if (requestParameters.game !== undefined) {
                            queryParameters['game'] = requestParameters.game;
                    }

                    if (requestParameters.groupby) {
                        queryParameters['groupby'] = requestParameters.groupby;
                    }

                    if (requestParameters.having !== undefined) {
                            queryParameters['having'] = requestParameters.having;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.index_on !== undefined) {
                            queryParameters['index_on'] = requestParameters.index_on;
                    }

                    if (requestParameters.kast !== undefined) {
                            queryParameters['kast'] = requestParameters.kast;
                    }

                    if (requestParameters.kills !== undefined) {
                            queryParameters['kills'] = requestParameters.kills;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.metrics) {
                        queryParameters['metrics'] = requestParameters.metrics;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.round_eco_type !== undefined) {
                            queryParameters['round_eco_type'] = requestParameters.round_eco_type;
                    }

                    if (requestParameters.round_eco_type_no_bonus !== undefined) {
                            queryParameters['round_eco_type_no_bonus'] = requestParameters.round_eco_type_no_bonus;
                    }

                    if (requestParameters.round_end !== undefined) {
                            queryParameters['round_end'] = requestParameters.round_end;
                    }

                    if (requestParameters.round_index !== undefined) {
                            queryParameters['round_index'] = requestParameters.round_index;
                    }

                    if (requestParameters.side !== undefined) {
                            queryParameters['side'] = requestParameters.side;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveTeamRoundSummaries/operations/aggregate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async aggregate(requestParameters: CompetitiveTeamRoundSummariesAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompetitiveTeamRoundSummariesAggregate>> {
                    const response = await this.competitiveTeamRoundSummariesAggregateRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveTeamRoundSummariesFieldValuesRaw(requestParameters: CompetitiveTeamRoundSummariesFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
                    if (requestParameters.field === null || requestParameters.field === undefined) {
                    throw new runtime.RequiredError('field','Required parameter requestParameters.field was null or undefined when calling competitiveTeamRoundSummariesFieldValues.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling competitiveTeamRoundSummariesFieldValues.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.assists !== undefined) {
                            queryParameters['assists'] = requestParameters.assists;
                    }

                    if (requestParameters.attack_pattern_full !== undefined) {
                            queryParameters['attack_pattern_full'] = requestParameters.attack_pattern_full;
                    }

                    if (requestParameters.attack_pattern_short !== undefined) {
                            queryParameters['attack_pattern_short'] = requestParameters.attack_pattern_short;
                    }

                    if (requestParameters.bomb_site !== undefined) {
                            queryParameters['bomb_site'] = requestParameters.bomb_site;
                    }

                    if (requestParameters.combat_score !== undefined) {
                            queryParameters['combat_score'] = requestParameters.combat_score;
                    }

                    if (requestParameters.damages !== undefined) {
                            queryParameters['damages'] = requestParameters.damages;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.deaths !== undefined) {
                            queryParameters['deaths'] = requestParameters.deaths;
                    }

                    if (requestParameters.defense_pattern_full !== undefined) {
                            queryParameters['defense_pattern_full'] = requestParameters.defense_pattern_full;
                    }

                    if (requestParameters.defense_pattern_short !== undefined) {
                            queryParameters['defense_pattern_short'] = requestParameters.defense_pattern_short;
                    }

                    if (requestParameters.field !== undefined) {
                            queryParameters['field'] = requestParameters.field;
                    }

                    if (requestParameters.first_blood !== undefined) {
                            queryParameters['first_blood'] = requestParameters.first_blood;
                    }

                    if (requestParameters.first_death !== undefined) {
                            queryParameters['first_death'] = requestParameters.first_death;
                    }

                    if (requestParameters.first_true_blood !== undefined) {
                            queryParameters['first_true_blood'] = requestParameters.first_true_blood;
                    }

                    if (requestParameters.first_true_death !== undefined) {
                            queryParameters['first_true_death'] = requestParameters.first_true_death;
                    }

                    if (requestParameters.game !== undefined) {
                            queryParameters['game'] = requestParameters.game;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.kast !== undefined) {
                            queryParameters['kast'] = requestParameters.kast;
                    }

                    if (requestParameters.kills !== undefined) {
                            queryParameters['kills'] = requestParameters.kills;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.round_eco_type !== undefined) {
                            queryParameters['round_eco_type'] = requestParameters.round_eco_type;
                    }

                    if (requestParameters.round_eco_type_no_bonus !== undefined) {
                            queryParameters['round_eco_type_no_bonus'] = requestParameters.round_eco_type_no_bonus;
                    }

                    if (requestParameters.round_end !== undefined) {
                            queryParameters['round_end'] = requestParameters.round_end;
                    }

                    if (requestParameters.round_index !== undefined) {
                            queryParameters['round_index'] = requestParameters.round_index;
                    }

                    if (requestParameters.side !== undefined) {
                            queryParameters['side'] = requestParameters.side;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveTeamRoundSummaries/operations/field-values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse<any>(response);
            }

            /**
            */
                async field_values(requestParameters: CompetitiveTeamRoundSummariesFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
                    const response = await this.competitiveTeamRoundSummariesFieldValuesRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveTeamRoundSummariesGetRaw(requestParameters: CompetitiveTeamRoundSummariesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitiveTeamRoundSummaries>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling competitiveTeamRoundSummariesGet.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveTeamRoundSummaries/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async get(requestParameters: CompetitiveTeamRoundSummariesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitiveTeamRoundSummaries> {
                    const response = await this.competitiveTeamRoundSummariesGetRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveTeamRoundSummariesListRaw(requestParameters: CompetitiveTeamRoundSummariesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompetitiveTeamRoundSummaries>>> {
            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.annotations) {
                        queryParameters['annotations'] = requestParameters.annotations;
                    }

                    if (requestParameters.assists !== undefined) {
                            queryParameters['assists'] = requestParameters.assists;
                    }

                    if (requestParameters.attack_pattern_full !== undefined) {
                            queryParameters['attack_pattern_full'] = requestParameters.attack_pattern_full;
                    }

                    if (requestParameters.attack_pattern_short !== undefined) {
                            queryParameters['attack_pattern_short'] = requestParameters.attack_pattern_short;
                    }

                    if (requestParameters.bomb_site !== undefined) {
                            queryParameters['bomb_site'] = requestParameters.bomb_site;
                    }

                    if (requestParameters.combat_score !== undefined) {
                            queryParameters['combat_score'] = requestParameters.combat_score;
                    }

                    if (requestParameters.damages !== undefined) {
                            queryParameters['damages'] = requestParameters.damages;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.deaths !== undefined) {
                            queryParameters['deaths'] = requestParameters.deaths;
                    }

                    if (requestParameters.defense_pattern_full !== undefined) {
                            queryParameters['defense_pattern_full'] = requestParameters.defense_pattern_full;
                    }

                    if (requestParameters.defense_pattern_short !== undefined) {
                            queryParameters['defense_pattern_short'] = requestParameters.defense_pattern_short;
                    }

                    if (requestParameters.first_blood !== undefined) {
                            queryParameters['first_blood'] = requestParameters.first_blood;
                    }

                    if (requestParameters.first_death !== undefined) {
                            queryParameters['first_death'] = requestParameters.first_death;
                    }

                    if (requestParameters.first_true_blood !== undefined) {
                            queryParameters['first_true_blood'] = requestParameters.first_true_blood;
                    }

                    if (requestParameters.first_true_death !== undefined) {
                            queryParameters['first_true_death'] = requestParameters.first_true_death;
                    }

                    if (requestParameters.game !== undefined) {
                            queryParameters['game'] = requestParameters.game;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.kast !== undefined) {
                            queryParameters['kast'] = requestParameters.kast;
                    }

                    if (requestParameters.kills !== undefined) {
                            queryParameters['kills'] = requestParameters.kills;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.only_values) {
                        queryParameters['only_values'] = requestParameters.only_values;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.round_eco_type !== undefined) {
                            queryParameters['round_eco_type'] = requestParameters.round_eco_type;
                    }

                    if (requestParameters.round_eco_type_no_bonus !== undefined) {
                            queryParameters['round_eco_type_no_bonus'] = requestParameters.round_eco_type_no_bonus;
                    }

                    if (requestParameters.round_end !== undefined) {
                            queryParameters['round_end'] = requestParameters.round_end;
                    }

                    if (requestParameters.round_index !== undefined) {
                            queryParameters['round_index'] = requestParameters.round_index;
                    }

                    if (requestParameters.side !== undefined) {
                            queryParameters['side'] = requestParameters.side;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveTeamRoundSummaries/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async list(requestParameters: CompetitiveTeamRoundSummariesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompetitiveTeamRoundSummaries>> {
                    const response = await this.competitiveTeamRoundSummariesListRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveTeamRoundSummariesVariableDistributionRaw(requestParameters: CompetitiveTeamRoundSummariesVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClientOrganizationVariableDistribution200ResponseInner>>> {
                    if (requestParameters.bucket_size === null || requestParameters.bucket_size === undefined) {
                    throw new runtime.RequiredError('bucket_size','Required parameter requestParameters.bucket_size was null or undefined when calling competitiveTeamRoundSummariesVariableDistribution.');
                    }

                    if (requestParameters.max === null || requestParameters.max === undefined) {
                    throw new runtime.RequiredError('max','Required parameter requestParameters.max was null or undefined when calling competitiveTeamRoundSummariesVariableDistribution.');
                    }

                    if (requestParameters.metric === null || requestParameters.metric === undefined) {
                    throw new runtime.RequiredError('metric','Required parameter requestParameters.metric was null or undefined when calling competitiveTeamRoundSummariesVariableDistribution.');
                    }

                    if (requestParameters.min === null || requestParameters.min === undefined) {
                    throw new runtime.RequiredError('min','Required parameter requestParameters.min was null or undefined when calling competitiveTeamRoundSummariesVariableDistribution.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.assists !== undefined) {
                            queryParameters['assists'] = requestParameters.assists;
                    }

                    if (requestParameters.attack_pattern_full !== undefined) {
                            queryParameters['attack_pattern_full'] = requestParameters.attack_pattern_full;
                    }

                    if (requestParameters.attack_pattern_short !== undefined) {
                            queryParameters['attack_pattern_short'] = requestParameters.attack_pattern_short;
                    }

                    if (requestParameters.bomb_site !== undefined) {
                            queryParameters['bomb_site'] = requestParameters.bomb_site;
                    }

                    if (requestParameters.bucket_size !== undefined) {
                            queryParameters['bucket_size'] = requestParameters.bucket_size;
                    }

                    if (requestParameters.combat_score !== undefined) {
                            queryParameters['combat_score'] = requestParameters.combat_score;
                    }

                    if (requestParameters.damages !== undefined) {
                            queryParameters['damages'] = requestParameters.damages;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.deaths !== undefined) {
                            queryParameters['deaths'] = requestParameters.deaths;
                    }

                    if (requestParameters.defense_pattern_full !== undefined) {
                            queryParameters['defense_pattern_full'] = requestParameters.defense_pattern_full;
                    }

                    if (requestParameters.defense_pattern_short !== undefined) {
                            queryParameters['defense_pattern_short'] = requestParameters.defense_pattern_short;
                    }

                    if (requestParameters.first_blood !== undefined) {
                            queryParameters['first_blood'] = requestParameters.first_blood;
                    }

                    if (requestParameters.first_death !== undefined) {
                            queryParameters['first_death'] = requestParameters.first_death;
                    }

                    if (requestParameters.first_true_blood !== undefined) {
                            queryParameters['first_true_blood'] = requestParameters.first_true_blood;
                    }

                    if (requestParameters.first_true_death !== undefined) {
                            queryParameters['first_true_death'] = requestParameters.first_true_death;
                    }

                    if (requestParameters.game !== undefined) {
                            queryParameters['game'] = requestParameters.game;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.kast !== undefined) {
                            queryParameters['kast'] = requestParameters.kast;
                    }

                    if (requestParameters.kills !== undefined) {
                            queryParameters['kills'] = requestParameters.kills;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.max !== undefined) {
                            queryParameters['max'] = requestParameters.max;
                    }

                    if (requestParameters.metric !== undefined) {
                            queryParameters['metric'] = requestParameters.metric;
                    }

                    if (requestParameters.min !== undefined) {
                            queryParameters['min'] = requestParameters.min;
                    }

                    if (requestParameters.round_eco_type !== undefined) {
                            queryParameters['round_eco_type'] = requestParameters.round_eco_type;
                    }

                    if (requestParameters.round_eco_type_no_bonus !== undefined) {
                            queryParameters['round_eco_type_no_bonus'] = requestParameters.round_eco_type_no_bonus;
                    }

                    if (requestParameters.round_end !== undefined) {
                            queryParameters['round_end'] = requestParameters.round_end;
                    }

                    if (requestParameters.round_index !== undefined) {
                            queryParameters['round_index'] = requestParameters.round_index;
                    }

                    if (requestParameters.side !== undefined) {
                            queryParameters['side'] = requestParameters.side;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveTeamRoundSummaries/operations/variable-distribution`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async variable_distribution(requestParameters: CompetitiveTeamRoundSummariesVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClientOrganizationVariableDistribution200ResponseInner>> {
                    const response = await this.competitiveTeamRoundSummariesVariableDistributionRaw(requestParameters, initOverrides);
                    return await response.value();
                }

        }
